// @flow
import React from 'react'
import renderHTML from 'react-render-html'
import { Accordion } from 'semantic-ui-react'
import TabMethodic from 'components/tabMethodic'
import './styles.scss'

export default class Methodic extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      activeIndex: [-1]
    }
  }

  handleClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    // const newIndex = activeIndex === index ? -1 : index
    // this.setState({ activeIndex: newIndex })
    const openIndex = activeIndex.indexOf(index)
    console.log('openIndex: ', openIndex)
    if (openIndex === -1) {
      const newArray = this.state.activeIndex.slice()
      newArray.push(index)
      this.setState({ activeIndex: newArray })
    } else {
      const newArray = this.state.activeIndex
      newArray.splice(openIndex, 1)
      this.setState({ activeIndex: newArray })
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'toggle tab: ' + titleProps.index
    })
  }

  render() {
    return (
      <div id='tabMethodic'>
        <Accordion fluid styled id='tabMethodic'>
          <TabMethodic
            activeIndex={this.state.activeIndex}
            // index={index}
            handleClick={this.handleClick}
            title={'Methodik'}
            // flag={q.n}
            // articleId={ARTICLE_ID}
          >
            {<div>{this.props.text}</div>}
          </TabMethodic>
        </Accordion>
      </div>
    )
  }
}